import commonApi from '@/api/common'
import { QINIU_UPLOAD_TOKEN_EXPIRE } from '@/constant/common'
import _ from 'lodash'
import Optional from 'optional-js'
import moment from 'moment'

const state = {
  uploadTokenInfo: {},
  privateFile: {},
  ossUploadTokenInfo: {}
}

const actions = {
  saveCommonUserBehavior ({ commit }, jobId) {
    return commonApi.saveCommonUserBehavior(jobId)
  },

  getWxApiTicket ({ commit }, url) {
    return commonApi.getWxApiTicket(url)
  },

  getWeComApiTicket (context, { weComAppId, url }) {
    return commonApi.getWeComApiTicket(weComAppId, url)
  },

  changeLanguage ({ commit }, language) {
    return commonApi.changeLanguage(language)
  },

  async getQiniuUploadToken ({ commit, state }, params) {
    const fileKey = params?.key
    if (fileKey) {
      const resp = Optional.ofNullable(await commonApi.getQiniuUploadToken(params)).map(item => item).orElse(null)
      const newToken = resp || {}
      newToken.expireDate = null
      return newToken
    }
    if (!params?.mode) {
      const tokenInfo = state.uploadTokenInfo
      if (tokenInfo.token && tokenInfo.expireDate && tokenInfo.expireDate > new Date().valueOf()) {
        // use old token
        return tokenInfo
      }
    }
    // old token is expired, and get new token
    const resp = Optional.ofNullable(await commonApi.getQiniuUploadToken(params)).map(item => item).orElse(null)
    const newToken = resp || {}
    if (newToken.token) {
      const expire = newToken.expire || QINIU_UPLOAD_TOKEN_EXPIRE
      newToken.expireDate = new Date().valueOf() + (expire - 10) * 1000
    }
    if (!params?.mode) {
      state.uploadTokenInfo = newToken
    }
    return newToken
  },

  compressVideo ({ commit }, params) {
    return commonApi.compressVideo(params)
  },

  watermarkVideo ({ commit }, params) {
    return commonApi.watermarkVideo(params)
  },

  getMediaPrefopStatus ({ commit }, params) {
    return commonApi.getMediaPrefopStatus(params)
  },

  getMediaInfo ({ commit }, key) {
    return commonApi.getMediaInfo(key)
  },

  batchDeletePosterImage ({ commit }, params) {
    return commonApi.batchDeletePosterImage(params)
  },

  trackWeChatShare (context, params) {
    return commonApi.trackWeChatShare(params)
  },
  getCurrencyList (context) {
    return commonApi.getCurrencyList()
  },
  getCountryCodeList (context) {
    return commonApi.getCountryCodeList()
  },
  getTimeZoneList (context, params) {
    return commonApi.getTimeZoneList(params)
  },
  async getPrivateFileUrl ({ state }, { fileType, fileKey }) {
    const privateFileKey = state.privateFile
    const now = new Date().valueOf()
    // removed expired fileUrlInfo
    let fileUrlInfo = _.get(privateFileKey, `${fileType}.${fileKey}`)
    if (!fileUrlInfo || fileUrlInfo.expireDate < now) {
      const resp = await commonApi.getPrivateFileUrl({
        type: fileType,
        key: fileKey
      })
      fileUrlInfo = {
        expire: resp.expire,
        expireDate: new Date().valueOf() + (resp.expire - 10) * 1000,
        fileUrl: resp.file_url
      }
    }
    return fileUrlInfo.fileUrl
  },
  checkHoliday () {
    return commonApi.checkHoliday()
  },
  async getOSSUploadToken ({ commit, state }, params) {
    const tokenInfo = state.ossUploadTokenInfo
    if (tokenInfo.access_key_id &&
        tokenInfo.access_key_secret &&
        tokenInfo.security_token &&
        moment().isBefore(moment(tokenInfo.expiration).subtract(3, 'minutes'))
    ) {
      // use old token
      return tokenInfo
    } else {
      const tokenInfo = await commonApi.getOSSUploadToken(params)
      commit('SET_OSS_TOKEN', tokenInfo)
      return tokenInfo
    }
  }
}

const mutations = {
  SET_OSS_TOKEN (state, tokenInfo) {
    state.ossUploadTokenInfo = tokenInfo
  }
}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
